/**
 * Cody brand logo components
 * - CodyIcon: Just the "C" icon (for sidebar, small placements)
 * - CodyFullLogo: Icon + "cody" text (for header, landing)
 * - CodyIconBadge: Icon in a rounded badge container (for login, signup, etc.)
 */

export function CodyIcon({ size = 32, className = '' }) {
  return (
    <img
      src="/cody-icon.png"
      alt="Cody"
      width={size}
      height={size}
      className={`rounded-lg object-cover ${className}`}
      style={{ width: size, height: size }}
    />
  );
}

export function CodyFullLogo({ height = 28, className = '' }) {
  return (
    <img
      src="/cody-full-logo.png"
      alt="Cody"
      className={`object-contain ${className}`}
      style={{ height }}
    />
  );
}

export function CodyIconBadge({ size = 40, className = '' }) {
  return (
    <div className={`rounded-xl overflow-hidden flex items-center justify-center shadow-sm ${className}`} style={{ width: size, height: size }}>
      <img
        src="/cody-icon.png"
        alt="Cody"
        className="w-full h-full object-cover"
      />
    </div>
  );
}
